export default {
  sidebar: {
    agentError: 'エージェントからの応答を取得できませんでした。',
    creditsExhausted:
      'このワークスペースは Khorium Agent の利用枠を使い切りました。続行するには管理者にお問い合わせください。',
    notEntitled:
      'このワークスペースでは、Khorium Agent の有効なシートまたはサブスクリプションがありません。ワークスペースの管理者にシートの割り当てを依頼するか、サポートにお問い合わせください。',
    updateSessionError: 'セッションを更新できませんでした',
    renameSessionError: 'セッションの名前を変更できませんでした',
    pinSessionError: 'セッションをピン留めできませんでした',
    loadHistoryError: 'セッション履歴を読み込めませんでした',
    loadTranscriptTimeout:
      'この会話の読み込みに時間がかかりすぎています。もう一度試すか、新しいチャットを開始してください。',
    loadTranscriptTooLarge:
      'この会話は大きすぎて読み込めません。新しいチャットを開始してください。',
    resizeHandle: 'チャットパネルのサイズを変更',
    untitled: '無題',
    updatedPrefix: '更新',
    newChat: '新しいチャット',
    newChatTooltip: '新しいチャット',
    showHistory: 'チャット履歴を表示',
    hideHistory: 'チャット履歴を非表示',
    showHistoryTooltip: 'チャット履歴を表示',
    hideHistoryTooltip: 'チャット履歴を非表示',
    restoringSession: '会話を復元しています…',
    maximize: '全画面表示にする',
    minimize: '全画面表示を終了',
    maximizeTooltip: '全画面表示にする',
    minimizeTooltip: '全画面表示を終了',
    collapse: 'チャットを折りたたむ',
    collapseTooltip: 'チャットを折りたたむ',
  },
  attachment: {
    imagePreviewAlt: '画像プレビュー',
    imagePreviewTitle: '画像添付ファイルのプレビュー',
    thumbAlt: '添付ファイルのプレビュー',
    typeImage: '画像',
    typeDocument: 'ドキュメント',
    typeFile: 'ファイル',
    tileLabel: '{{type}}の添付ファイル',
    chipLabel: '{{type}}の添付ファイル: {{name}}',
    removeFile: 'ファイルを削除',
    addAttachment: 'CADパーツを添付',
    addAttachmentTooltip: 'CADパーツを添付 ({{types}})',
    uploadFailed: 'アップロードに失敗しました',
  },
  sessionList: {
    loadError: 'セッションを読み込めませんでした',
    header: 'チャット履歴',
    searchPlaceholder: 'チャットを検索…',
    loading: 'チャット履歴を読み込んでいます…',
    emptyNoMatch: '一致するチャットはありません。',
    emptyNone: 'まだチャット履歴はありません。',
    emptyNoAutoRetry: 'まだ AI リトライの記録はありません。',
    scopeLabel: 'セッションの種類',
    scopeChats: 'チャット',
    scopeAutoRetry: 'AI リトライ',
    pinned: 'ピン留め済み',
    recent: '最近',
    untitled: '無題のチャット',
    unpin: 'チャットのピン留めを解除',
    pin: 'チャットをピン留め',
    unpinTooltip: 'チャットのピン留めを解除',
    pinTooltip: 'チャットをピン留め',
    rename: 'チャットの名前を変更',
    renameTooltip: 'チャットの名前を変更',
  },
  thread: {
    helpful: '役に立った',
    unhelpful: '役に立たなかった',
    welcomeTitle: 'こんにちは！',
    welcomeSubtitle: '今日はどのようなお手伝いをしましょうか？',
    scrollToBottom: '一番下までスクロール',
    inputPlaceholder: 'メッセージを送信…',
    inputLabel: 'メッセージ入力',
    screenshotOn: 'ビューポートのスクリーンショットがオン',
    screenshotOff: 'ビューポートのスクリーンショットがオフ',
    toggleScreenshot: 'ビューポートのスクリーンショットを切り替え',
    approvalMode: 'ツール承認',
    approvalAuto: '自動承認',
    approvalAutoShort: '自動',
    approvalManual: '手動 — 毎回確認',
    approvalManualShort: '手動',
    sendMessage: 'メッセージを送信',
    waitingForUpload: '{{file}} のアップロード完了を待っています',
    waitingForApproval: '先に上の確認に回答してください',
    stopGenerating: '生成を停止',
    queueMessage: 'この返答の後に送信',
    queuedHeading: '送信待ち',
    queueRemove: '送信待ちから削除',
    connectionLostWaiting: '接続が切れました。返答の完了を待っています。',
    connectionLost:
      'エージェントがまだ処理中か確認できません。更新して再確認してください。',
    runWorking:
      'エージェントが処理中です。準備ができ次第、ここに返答が表示されます。',
    runAwaitingClient:
      '元のブラウザーでの操作が必要です。繰り返す前に結果を確認してください。',
    runFailed:
      'エージェントは処理を完了できませんでした。保存済みの進捗は上に表示されます。',
    runCancelled: '処理は停止されました。保存済みの進捗は上に表示されます。',
    copy: 'コピー',
    refresh: '再生成',
    refreshHeldForApproval: '先に上の質問に答えてください',
    more: 'その他',
    exportMarkdown: 'Markdown としてエクスポート',
    edit: '編集',
    editCancel: 'キャンセル',
    editUpdate: '更新',
    branchPrevious: '前へ',
    branchNext: '次へ',
  },
  approval: {
    titleBackend: 'アシスタントにこの操作を任せますか？',
    subtitleBackend:
      '保存済みの作業を変更するか、費用が発生する処理を開始します。',
    allowOnce: '今回だけ許可',
    deny: '拒否',
    working: '処理中…',
    cancelled: '操作がキャンセルされました',
    approved: '操作が承認されました',
    skipped: '操作がスキップされました',
    failed: '操作が失敗しました',
    askedBecauseManual: '承認モードが「手動」のため確認しています',
    handCalcSet: '{{count}} 件を追加または置換：',
    handCalcRemove: '{{count}} 件を削除：',
    handCalcNew: '新規',
    handCalcReplacesEngineer: 'エンジニアのものを置換',
    handCalcReplacesAgent: 'AI のものを置換',
    handCalcEngineers: 'エンジニアのもの',
    handCalcAgents: 'AI のもの',
    handCalcMore: 'ほか {{count}} 件',
  },
  toolCalls: {
    verbMeshSettings: 'メッシュサイズを設定',
    verbBoundaryLayer: '境界層を設定',
    verbViewerSettings: 'ビューアを設定',
    verbDomainParams: '流体領域を設定',
    verbInspect: '設定を読み取る',
    verbPrepare: 'メッシュを準備する',
    verbRun: 'スタディを実行する',
    verbSimopsDraft: 'SimOps の設定を編集',
    verbRetryPoint: '設計点を再試行',
    usedTool: '使用したツール',
    targetMeshSetup: 'メッシュ設定',
    targetViewer: 'ビューア',
    targetDomain: '流体領域',
    targetGuidance: 'Khorium ガイダンス',
    valueOn: 'オン',
    valueOff: 'オフ',
    noChange: '変更はありません',
    arguments: '引数',
    result: '結果',
    group_one: 'ツール呼び出し {{count}} 件',
    group_other: 'ツール呼び出し {{count}} 件',
    retry: '再試行',
    skip: 'スキップ',
    retryMessage: '{{step}} を再試行',
    skipMessage: '{{step}} をスキップ',
    sentBack: 'アシスタントに差し戻され、再試行が求められました',
    openStudy: 'SimOps でスタディを開く',
    openDesignPoint: 'SimOps で設計点を開く',
    openMesh: 'MeshGen でメッシュを開く',
    openPage: 'ページを開く',
    openGeometry: 'MeshGen で開きますか？',
    openGeometryFailed: 'MeshGen を開けませんでした。もう一度お試しください。',
  },
  reasoning: {
    inProgress: '思考中…',
    unfinished: '思考（未完了）',
    done: '思考',
  },
  plan: {
    summary: 'プラン {{done}}/{{total}}',
    summaryWithStep: 'プラン {{done}}/{{total}} · {{step}}',
  },
  linkedPages: {
    button: 'リンクされたページ',
    buttonTooltip: 'リンクされたページ',
    title: 'このチャットのリンク',
    empty: 'アシスタントがリンクしたページがここに表示されます。',
    detail: {
      dp: 'DP',
      mesh: 'メッシュ',
    },
  },
} as const;
